import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Grid, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { Link, PagesTitle, Button } from '../../../components';
import { CheckCircleIcon, BanIcon } from '../../../components/icon/solid';
import PageContainer from '../PageContainer';
import { useTitle } from '../../../hooks';
import { Links } from '../../../utility/links';


const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.menuAction.selected,
  },
  declineIcon: {
    height: '64px',
    width: '64px',
    color: palette.error.main,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
    marginBottom: '42px',

    '& p': {
      marginBlockStart: 0,
    },
  },
  button: {
    minWidth: '189px',
    borderRadius: '5px',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    textTransform: 'none',
    marginBottom: '42px',
  },
  buttonBlue: {
    backgroundColor: palette.menuAction.selected,
    color: palette.common.white,
    '&:hover': {
      backgroundColor: palette.menuAction.selected,
    },
  },
  buttonPrimary: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  buttonLink: {
    display: 'inline-flex',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
}), { name: 'InvitationPage' });

type Props = {
  accepted: boolean;
  register: boolean;
  auth: boolean;
};

const InvitationSuccess = ({ accepted, register, auth } : Props) => {
  const classes = useStyles();

  useTitle('Invitation');

  const title = accepted ? 'Invitation Accepted' : 'Invitation Declined';
  const text = accepted ? 'Thank you for accepting the team invitation to PitchHub.' : 'You have declined the team invitation into PitchHub.';

  const secondaryText = accepted
    ? auth ? 'See what your team has been working on in ClipPress.'
      : register ? 'Please register to get started!' : 'Please log in to get started!'
    : 'Learn more about PitchHub or try for free!';

  const link = auth ? '/dashboard/projects' : register ? '/pages/register' : '/pages/login';
  const textLink = auth ? 'ClipPress' : register ? 'Register' : 'Log in';

  return (
    <PageContainer>
      <Grid container className={classes.root}>
        {
          accepted
            ? <CheckCircleIcon className={classes.icon} />
            : <BanIcon className={classes.declineIcon} />
        }
        <PagesTitle className={classes.title}>{title}</PagesTitle>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>{text}</p>
          <p>{secondaryText}</p>
        </Typography>
        {
          accepted
            ? (
              <Link to={link} className={classes.buttonLink}>
                <Button className={clsx(classes.button, classes.buttonBlue)}>
                  {textLink}
                </Button>
              </Link>
            )
            : (
              <div className={classes.buttonContainer}>
                <Link to={Links.blog} className={classes.buttonLink}>
                  <Button
                    variant="contained"
                    className={clsx(classes.button, classes.buttonBlue)}
                  >
                  Learn More
                  </Button>
                </Link>
                <Link to="/pages/register" className={classes.buttonLink}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={clsx(classes.button, classes.buttonPrimary)}
                  >
                  Try for free!
                  </Button>
                </Link>
              </div>
            )
        }
      </Grid>
    </PageContainer>
  );
};


export default InvitationSuccess;
